import { useRef } from "react";

export default function useSCREffect(callback,deps=[]) {
  var isFirstTimeRef=useRef(true)
  let called=false
  for(let oneDep of deps) {
    const ref=useRef(oneDep)
    if(called) continue
    if(ref.current !=oneDep || isFirstTimeRef.current) {
      ref.current=oneDep
      called=true
      callback()
    }
  }
  isFirstTimeRef.current=false
}